import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_5179_59174)" }, [
      _createElementVNode("path", {
        d: "M0.5 4.5V6H14.75V17.25H10.133C9.7985 15.9607 8.639 15 7.25 15C5.861 15 4.7015 15.9607 4.367 17.25H3.5V13.5H2V18.75H4.367C4.7015 20.0393 5.861 21 7.25 21C8.639 21 9.7985 20.0393 10.133 18.75H16.367C16.7015 20.0393 17.861 21 19.25 21C20.639 21 21.7985 20.0393 22.133 18.75H24.5V12.633L24.4528 12.5153L22.9528 8.01525L22.79 7.5H16.25V4.5H0.5ZM1.25 7.5V9H8V7.5H1.25ZM16.25 9H21.7108L23 12.8438V17.25H22.133C21.7985 15.9607 20.639 15 19.25 15C17.861 15 16.7015 15.9607 16.367 17.25H16.25V9ZM2 10.5V12H6.5V10.5H2ZM7.25 16.5C8.08775 16.5 8.75 17.1622 8.75 18C8.75 18.8378 8.08775 19.5 7.25 19.5C6.41225 19.5 5.75 18.8378 5.75 18C5.75 17.1622 6.41225 16.5 7.25 16.5ZM19.25 16.5C20.0877 16.5 20.75 17.1622 20.75 18C20.75 18.8378 20.0877 19.5 19.25 19.5C18.4123 19.5 17.75 18.8378 17.75 18C17.75 17.1622 18.4123 16.5 19.25 16.5Z",
        fill: "#AA1E2D"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_5179_59174" }, [
        _createElementVNode("rect", {
          width: "24",
          height: "24",
          fill: "white",
          transform: "translate(0.5)"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }